/**
 * Turn `celery_task_log.result` into alert text: one "key: value" line per field.
 * Nested objects are flattened (e.g. msg.Forums: …, status_code: 200).
 *
 * @param {unknown} result - `celery_task_log.result` from GET /get-celery-task-log
 * @returns {string}
 */
export function formatCeleryTaskResultForAlert(result) {
  if (result == null) {
    return "";
  }
  if (typeof result !== "object") {
    return String(result);
  }
  if (Array.isArray(result)) {
    return result.map((item) => String(item)).join("\n");
  }

  return objectToLines(result).join("\n");
}

/**
 * @param {Record<string, unknown>} obj
 * @param {string} [prefix]
 * @returns {string[]}
 */
function objectToLines(obj, prefix = "") {
  return Object.entries(obj).flatMap(([key, value]) => {
    const lineKey = prefix ? `${prefix}.${key}` : key;

    if (value != null && typeof value === "object" && !Array.isArray(value)) {
      return objectToLines(value, lineKey);
    }

    if (Array.isArray(value)) {
      return value.flatMap((item, idx) =>
        typeof item === "object" && item != null
          ? objectToLines(item, `${lineKey}[${idx}]`)
          : [`${lineKey}[${idx}]: ${String(item)}`]
      );
    }

    return [`${lineKey}: ${value == null ? "" : String(value)}`];
  });
}
